import { DOCS_URL } from "../../../config/constants.js";
import ContentAndForm from "./ContentAndForm.svelte";

export default {
    component: ContentAndForm,
    name: "Content And Form",
    description: "Standard Content And Form component to contain content and form elements",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/columns-2.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2Fe34b976242cd4d2995b4e22cc2c98a70",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-contentandform--docs`,
    canHaveChildren: false,
    inputs: [
        {
            friendlyName: "Text",
            name: "text",
            type: "richText",
        },
        {
            friendlyName: "HubSpot Form ID",
            name: "formId",
            type: "string",
            required: true,
            helperText:
                "The GUID of the HubSpot form. Find this in HubSpot: Marketing > Lead Capture > Forms > [Your Form] > Form Options > Share > Copy the form ID from the embed code.",
        },
        {
            friendlyName: "Portal ID (Optional)",
            name: "portalId",
            type: "string",
            required: false,
            helperText:
                "Override the default HubSpot portal ID. Leave empty to use the environment default.",
        },
        {
            friendlyName: "Field Layout",
            name: "fieldLayout",
            type: "enum",
            enum: [
                {
                    label: "Single Column",
                    value: "single-column",
                },
                {
                    label: "Double Column",
                    value: "double-column",
                },
            ],
            defaultValue: "double-column",
            helperText:
                "Select the layout for form fields. 'Double Column' pairs common fields (firstname/lastname, email/phone, company/job title) in two-column rows on tablet and above. 'Single Column' stacks all fields in a single column.",
        },
        {
            friendlyName: "Show Newsletter Checkbox",
            name: "showMailchimpCheckbox",
            type: "boolean",
            defaultValue: false,
            helperText:
                "Add a checkbox to subscribe the user to the Mailchimp newsletter (double opt-in).",
        },
        {
            friendlyName: "Newsletter Checkbox Label",
            name: "mailchimpCheckboxLabel",
            type: "string",
            defaultValue: "Subscribe to our newsletter",
            showIf: `options.get('showMailchimpCheckbox') === true`,
            helperText: "Custom label for the newsletter subscription checkbox.",
        },
        {
            friendlyName: "Success Message",
            name: "successMessage",
            type: "richText",
            defaultValue: "<p>Thank you for your submission!</p>",
            helperText:
                "Rich text content displayed after successful form submission. Supports headings, links, lists, and basic formatting.",
        },
        {
            friendlyName: "Success Replacement Scope",
            name: "successReplacementScope",
            type: "enum",
            enum: [
                {
                    label: "Replace form only",
                    value: "form",
                },
                {
                    label: "Replace whole block",
                    value: "block",
                },
            ],
            defaultValue: "form",
            helperText:
                "Choose whether a successful submission replaces only the form column or the whole content-and-form block.",
        },
        {
            friendlyName: "Block Success Message",
            name: "blockSuccessMessage",
            type: "richText",
            defaultValue: "<p>Thank you for your submission!</p>",
            showIf: `options.get('successReplacementScope') === 'block'`,
            helperText:
                "Rich text content displayed when the whole content-and-form block is replaced after successful submission.",
        },
        {
            friendlyName: "Replace Container on Success (Legacy)",
            name: "replaceContainerOnSuccess",
            type: "boolean",
            defaultValue: false,
            advanced: true,
            helperText:
                "Legacy option. For this component it now replaces only the Content And Form block, not the full page container.",
        },
        {
            friendlyName: "Submit Button Text",
            name: "submitButtonText",
            type: "string",
            defaultValue: "Submit",
            helperText: "Text displayed on the form submit button.",
        },
        {
            friendlyName: "Conditions Text",
            name: "conditionsText",
            type: "longText",
            defaultValue: "",
            helperText:
                "Optional conditions or consent text displayed before the submit button (e.g. event registration disclaimers).",
        },
        {
            friendlyName: "Additional CSS Classes",
            name: "className",
            type: "string",
            required: false,
            helperText: "Optional CSS classes to add to the form container.",
            advanced: true,
        },
    ],
};
